// PurchaseOrderDetailModal.js
import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Status from '../../../components/ui/Status';
import { Modal } from 'bootstrap';
import ItemViewInList from '../includes/ItemViewInList';
import tapIcon from '../../../services/TapIcon';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import POHistoryModal from './POHistoryModal';
import NumberFormatter from '../../../services/NumberFormater';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import PurchaseOrderDocument from './PurchaseOrderDocument';
import { Link } from 'react-router-dom';
import DateService from '../../../services/DateService';
import { toast } from 'react-toastify';
import TapSelect from '../../../components/ui/TapSelect';
import download from '../../../services/DownloadFile';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ItemTransactionLedger from '../includes/ItemTransactionLedger';
import RequisitionDetailModal from '../requisition/RequisitionDetailModal';
import VendorDetailModal from '../../groupData/vendor/VendorDetailModal';
import LogisticViewModal from '../logistic/LogisticViewModal';
import HistoryDataModal from '../HistoryDataModal';
import POCancel from './POCancel';
import uuid from "react-uuid";

class PurchaseOrderDetailModal extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            detail_loading: false,
            poDetail: null,
            poTransactionId: null,
            addCommentForm: { status: '', notes: ' ' },
            allAllowedStatus: [],
            addCommentFormSubmitting: false,
            pdfDownloading: false,
            cancelledItemList: [],
            cancel_item_loading: false,
            cancelItemFormSubmitting: false,
            cancelledItemForm: { notes: '' },
            _loadingTransactionId: null,
        };
        
        // Initialize all refs
         this.itemDetailsRef = React.createRef();
        this.ReqDetailModalRef = React.createRef();
        this.VendorDetailModalRef = React.createRef();
        this.LogisticViewModalRef = React.createRef();
        this.HistoryRef = React.createRef();
        this.cancelledItemModalRef = React.createRef();
        this.myRef = React.createRef();
        this.PODetailModalID =  uuid()
        
        this.purchaseOrderUrl = INVENTORY_API_BASE_URL_2 + '/purchase_order';
        this.poReportUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase-order';
        this.updateCommentFormInit = { status: '', notes: ' ' };
        this.cancelItemFormInit = { notes: '' };
    }

    componentDidMount = () => {
        // Only initialize modal if not rendering inline
        if (this.props.renderAs !== 'inline') {
            this.poDetailModal = new Modal(document.getElementById(this.PODetailModalID), {keyboard: false, backdrop: false});
        }
        
        // If transaction_id is passed as prop, load detail
        if (this.props.transaction_id && !this.state.poDetail) {
            this.getPODetail(this.props.transaction_id);
        }
    }

    componentDidUpdate(prevProps) {
        const { transaction_id } = this.props;
        const { poTransactionId, detail_loading, _loadingTransactionId } = this.state;
        
      
        if (transaction_id && 
            transaction_id !== prevProps.transaction_id && 
            transaction_id !== poTransactionId &&
            !detail_loading &&
            _loadingTransactionId !== transaction_id) {
            this.getPODetail(transaction_id);
        }
    }

    modalPOInit = (transaction_id) => {
        if (this.poDetailModal) {
            this.poDetailModal.show();
        }
        this.getPODetail(transaction_id);
    }

    refreshPODetail = (transaction_id) => {
    if (transaction_id) {
        this.getPODetail(transaction_id, true);
    } else if (this.state.poTransactionId) {
        this.getPODetail(this.state.poTransactionId, true);
    }
}

    scrollToComment = () => {
        if (this.myRef.current) {
            this.myRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    getPODetail = (transaction_id, forceRefresh = false) => {
        // If we already have this transaction loaded and not forcing refresh, don't reload
        if (!forceRefresh && this.state.poTransactionId === transaction_id && this.state.poDetail) {
            return;
        }

        // Prevent duplicate calls
        if (this.state.detail_loading || this.state._loadingTransactionId === transaction_id) {
            return;
        }

        this.setState({
            detail_loading: true,
            _loadingTransactionId: transaction_id
        });

        HttpAPICall.withAthorization('GET', this.purchaseOrderUrl + '/' + transaction_id, this.props.access_token, { need_documents: "Y" }, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                poDetail: respData.data,
                poTransactionId: respData.data.transaction_id,
                allAllowedStatus: respData.data && respData.data.user_status && respData.data.user_status.length > 0 ?
                    respData.data.user_status.map((s) => { return { value: s.id, label: s.name }; }) : [],
                addCommentForm: { ...this.updateCommentFormInit, status: respData.data.status },
                detail_loading: false,
                _loadingTransactionId: null,
            });

            if (this.props.onDetailLoaded) {
                this.props.onDetailLoaded(respData.data);
            }
        }).catch(() => {
            this.setState({
                detail_loading: false,
                _loadingTransactionId: null
            });
        });
    }


    // View methods
    viewItemModalInit = (item) => {
        console.log(item,'kk',this.itemDetailsRef)
        if (item && this.itemDetailsRef.current) {
            this.itemDetailsRef.current.modalInit(item);
        }
    }



    viewHistoryModalInit = (data, defaultAction = 'consumption', extraParams = {}) => {
        if (this.state.poDetail && data && this.HistoryRef.current) {
            let poDetail = this.state.poDetail;
            this.HistoryRef.current.modalHistoryInit(data, {
                warehouse_id: poDetail?.warehouse_id,
                asset_id: poDetail?.asset_id,
                workstation_id: null,
                warehouse_detail: poDetail?.warehouse,
                indent_transaction_id: extraParams.indent_transaction_id || '',
                req_item_id: extraParams.req_item_id || '',
                showTransactionType: extraParams.showTransactionType || false,
                defaultAction: defaultAction,
                historyTypes: [
                    { value: 'consumption', label: 'Consumption History' },
                    { value: 'po_history', label: 'PO History' },
                    { value: 'transaction_ledger', label: 'Item Transaction Ledger' }
                ]
            });
        }
    }

    reqDetailModalInit = (req_item_id) => {
        if (this.ReqDetailModalRef.current) {
            this.ReqDetailModalRef.current.modalReqInit(req_item_id);
        }
    }

    vendorDetailModalInit = (id) => {
        if (this.VendorDetailModalRef.current) {
            this.VendorDetailModalRef.current.modalInit(id);
        }
    }

    logisticDetailModal = (val) => {
        if (this.LogisticViewModalRef.current) {
            this.LogisticViewModalRef.current.showModalInit(val);
        }
    }

    // Comment/Status update
    submitUpdateCommentForm = (e) => {
        e.preventDefault();
        this.setState({ addCommentFormSubmitting: true });
        let frmData = {
            ...this.state.addCommentForm,
            transaction_id: this.state.poTransactionId
        };
        HttpAPICall.withAthorization('PUT', this.purchaseOrderUrl + '/comment', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getPODetail(this.state.poTransactionId);
            if (this.props.onUpdate) {
                this.refreshPODetail(this.state.poTransactionId)
                this.props.onUpdate(this.state.poTransactionId);
            }
            this.setState({ addCommentForm: { ...this.updateCommentFormInit } });
        }).then(() => this.setState({ addCommentFormSubmitting: false }));
    }

    // Download handlers
    downloadPdfHandler = (transaction_id, use_for = 'internal') => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', this.purchaseOrderUrl + '/' + transaction_id, this.props.access_token, { download: "download", use_for: use_for }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    reportDownloadApiHandler = (transaction_id) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', this.poReportUrl, this.props.access_token, { search_transaction_id: transaction_id, download: 'download' }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    // Cancel Item methods
    checkAllCancelItem = () => {
        let poItemCollections = document.getElementsByClassName('po_item_id_checkbox');
        const allChecked = document.getElementById('all_check_po')?.checked || false;
        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                poItemCollections[i].checked = allChecked;
            }
        }
    }

    cancelPOItem = (transaction_id) => {
        this.setState({ cancel_item_loading: true });
        
        let cancelledItemList = [];
        let showErrorMessage = false;
        let poItemCollections = document.getElementsByClassName('po_item_id_checkbox');
        
        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                if (poItemCollections[i].checked) {
                    let itemId = poItemCollections[i].value;
                    let data = this.state.poDetail.items.find(i => i.item.id == itemId);
                    let row = { ...cancelledItemList[i], ...data };
                    cancelledItemList[i] = row;
                }
            }
        }

        let list = cancelledItemList.filter(Boolean);
        if (list.length == 0 && !showErrorMessage) {
            toast.error('Please select an Item for Cancellation', { position: toast.POSITION.TOP_RIGHT });
            this.setState({ cancel_item_loading: false });
        } else {
            this.setState({
                cancelledItemList: [...list],
                cancelledItemForm: { ...this.cancelItemFormInit }
            }, () => {
                if (this.cancelledItemModalRef.current) {
                    this.cancelledItemModalRef.current.modalInit(list, this.state.poTransactionId);
                }
                this.setState({ cancel_item_loading: false });
            });
        }
    }

    // Get action modals for parent
    getCancelModal = () => this.cancelledItemModalRef;

    // Helper methods
    forDataViewInTr = (forType, data) => {
        switch(forType) {
            case "asset":
                return `Asset : <span>${data.assetProfile ? data.assetProfile.name : ''}</span>`;
            case "workstation":
                return `Workstation : <span>${data.workstation ? data.workstation.workstation_name : ''}</span>`;
            case "employee":
                return `Employee : <span>${data.employee ? data.employee.name : ''}</span>`;
            case "sub_assembly":
                return `Sub Assembly : <span>${data.sub_assembly ? data.sub_assembly.name : ''}</span>`;
            case "customer":
                return `Customer : <span>${data.customer ? data.customer.name : ''}</span>`;
            default:
                return '';
        }
    }

    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    }

    tapSelectChange = (selectedOption, formName, fieldName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [fieldName]: selectedOption ? selectedOption.value : null
            }
        });
    }

    // Render detail content (reused for both modal and inline)
    renderDetailContent = () => {
        let purchaseOrder = this.state.poDetail;
        
        if (this.state.detail_loading) {
            return <Loader />;
        }
        
        if (!purchaseOrder) {
            return <div className="text-center p-5">No purchase order selected</div>;
        }

        let purchase_summary = [];
        if (purchaseOrder && purchaseOrder.vendor_state == purchaseOrder.warehouse_state) {
            purchase_summary.push({ key: 'CGST ', value: "As applicable" });
            purchase_summary.push({ key: 'SGST ', value: "As applicable" });
        } else {
            purchase_summary.push({ key: 'IGST ', value: "As applicable" });
        }

        let sub_total_amount = purchaseOrder && purchaseOrder.items && purchaseOrder.items.length > 0 && 
            purchaseOrder.items.map(s => s.item_with_discount).reduce((a, b) => a + b, 0);

        let tcs_amount = purchaseOrder && Number(purchaseOrder.tcs_rate && purchaseOrder.tcs_rate >= 0
            ? purchaseOrder && purchaseOrder.tcs_type == "Percentage" ? (sub_total_amount * purchaseOrder.tcs_rate / 100) : Number(purchaseOrder.tcs_rate)
            : 0);

        return (
            <div>
                <table className="table table-bordered bg-white">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ width: "33%" }}>ID</th>
                            <th style={{ width: "33%" }}>Date</th>
                            <th style={{ width: "33%" }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{purchaseOrder.transaction_id}</td>
                            <td>{purchaseOrder.transaction_date_display}</td>
                            <td className="align-middle">
                                {purchaseOrder.status_data ? purchaseOrder.status_data.name : ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table className="table table-hover table-bordered table-responsive bg-white mb-0">
                    <tbody>
                        <tr>
                            <td style={{ width: "33%" }}>Purchase Order Type</td>
                            <td colSpan={2}>{purchaseOrder.purchase_order_type_name ? purchaseOrder.purchase_order_type_name : ""}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }} rowSpan={2}>Warehouse (Delivery Address)</td>
                            <td colSpan={2}>
                                {purchaseOrder.warehouse ? (
                                    <Ax>
                                        <div>
                                            <b>{purchaseOrder.warehouse.name} ({purchaseOrder.warehouse.code})</b> <br />
                                            Organization : {purchaseOrder.warehouse && purchaseOrder.warehouse.organization ? purchaseOrder?.warehouse?.organization?.name : this.props?.orgInfoData?.group_name}
                                        </div>
                                    </Ax>
                                ) : null}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div><b>Bill To Address</b></div>
                                {purchaseOrder.warehouse ? (
                                    <div>
                                        {purchaseOrder.warehouse_address ? (
                                            <div className='pt-1'>
                                                {purchaseOrder.warehouse_address.label ? <span>{purchaseOrder.warehouse_address.label} <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.address1 ? <span>{purchaseOrder.warehouse_address.address1}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.address2 ? <span>{purchaseOrder.warehouse_address.address2}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.landmark ? <span>{purchaseOrder.warehouse_address.landmark}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.city ? <span>{purchaseOrder.warehouse_address.city}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address && purchaseOrder.warehouse_address.state_name ? <span> State : <b>{purchaseOrder.warehouse_address.state_name}</b> <br /></span> : ""}
                                                {purchaseOrder.warehouse_address && purchaseOrder.warehouse_address.gstin ? <span>GSTIN : <b>{purchaseOrder.warehouse_address.gstin}</b> <br /></span> : ""}
                                            </div>
                                        ) : "-"}
                                    </div>
                                ) : "-"} <br />
                            </td>
                            <td>
                                <div><b>Ship To Address</b></div>
                                {purchaseOrder.warehouse_shipping_address ? (
                                    <div className='pt-1'>
                                        {purchaseOrder.warehouse_shipping_address.label ? <span>{purchaseOrder.warehouse_shipping_address.label} <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address.address1 ? <span>{purchaseOrder.warehouse_shipping_address.address1}, <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address.address2 ? <span>{purchaseOrder.warehouse_shipping_address.address2}, <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address.landmark ? <span>{purchaseOrder.warehouse_shipping_address.landmark}, <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address.city ? <span>{purchaseOrder.warehouse_shipping_address.city}, <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address && purchaseOrder.warehouse_shipping_address.state_name ? <span> State : <b>{purchaseOrder.warehouse_shipping_address.state_name}</b> <br /></span> : ""}
                                        {purchaseOrder.warehouse_shipping_address && purchaseOrder.warehouse_shipping_address.gstin ? <span>GSTIN : <b>{purchaseOrder.warehouse_shipping_address.gstin}</b> <br /></span> : ""}
                                    </div>
                                ) : (
                                    <div className='pt-1'>
                                        {purchaseOrder.warehouse_address ? (
                                            <div className='pt-1'>
                                                {purchaseOrder.warehouse_address.label ? <span>{purchaseOrder.warehouse_address.label} <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.address1 ? <span>{purchaseOrder.warehouse_address.address1}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.address2 ? <span>{purchaseOrder.warehouse_address.address2}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.landmark ? <span>{purchaseOrder.warehouse_address.landmark}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address.city ? <span>{purchaseOrder.warehouse_address.city}, <br /></span> : ""}
                                                {purchaseOrder.warehouse_address && purchaseOrder.warehouse_address.state_name ? <span> State : <b>{purchaseOrder.warehouse_address.state_name}</b> <br /></span> : ""}
                                                {purchaseOrder.warehouse_address && purchaseOrder.warehouse_address.gstin ? <span>GSTIN : <b>{purchaseOrder.warehouse_address.gstin}</b> <br /></span> : ""}
                                            </div>
                                        ) : "-"}
                                    </div>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }}>Vendor</td>
                            <td colSpan={2}>
                                {purchaseOrder.vendor ? (
                                    <div>
                                        <a className='link-primary cursor_pointer' onClick={() => this.vendorDetailModalInit(purchaseOrder?.vendor?.id)}>
                                            {purchaseOrder.vendor.name} ({purchaseOrder.vendor.code})
                                        </a> <br />
                                        {purchaseOrder.vendor_address ? (
                                            <div className='py-1'>
                                                {purchaseOrder.vendor_address.label ? purchaseOrder.vendor_address.label : ""}
                                                Address : {purchaseOrder.vendor_address.address1 ? purchaseOrder.vendor_address.address1 + ", " : ""}
                                                {purchaseOrder.vendor_address.address2 ? purchaseOrder.vendor_address.address2 + ", " : ""}
                                                {purchaseOrder.vendor_address.landmark ? purchaseOrder.vendor_address.landmark + ", " : ""}
                                                {purchaseOrder.vendor_address.city ? purchaseOrder.vendor_address.city + ". " : "-"} <br />
                                                Source of Supply : <b>{purchaseOrder.vendor_address.state_name} ({purchaseOrder.vendor_address.country_name}) </b> <br />
                                                GSTIN : {purchaseOrder.vendor_gstin ?? "-"}
                                            </div>
                                        ) : "-"}
                                        {purchaseOrder.po_display_vendor_contact && purchaseOrder.po_display_vendor_contact == 'Y' && purchaseOrder.vendor_contact && (
                                            <div className='py-1'>
                                                Name : {purchaseOrder.vendor_contact.name} | Contact No. : {purchaseOrder.vendor_contact.mobile} | Email : {purchaseOrder.vendor_contact.email}
                                            </div>
                                        )}
                                    </div>
                                ) : "-"}
                            </td>
                        </tr>
                        {purchaseOrder.po_allow_po_for && purchaseOrder.po_allow_po_for == 'Y' && (
                            <tr>
                                <td style={{ width: "33%" }}>Purchase Order For</td>
                                <td colSpan={2} dangerouslySetInnerHTML={{ __html: this.forDataViewInTr(purchaseOrder.po_for, purchaseOrder) }} />
                            </tr>
                        )}
                        {this.props.settings && this.props.settings['ticket_purchase_order'] === "Y" && (
                            <tr>
                                <td style={{ width: "33%" }}>Ticket</td>
                                <td colSpan={2}>
                                    {purchaseOrder.ticket_data ? `${purchaseOrder.ticket_data.activity_id} : ${purchaseOrder.ticket_data.header}` : ''}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>Priority & Delivery Date</td>
                            <td style={{ width: "33%" }} className="text-capitalize">{purchaseOrder.priority ?? "-"}</td>
                            <td style={{ width: "34%" }}>{purchaseOrder.expected_delivery_date_display ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Quotation Number & Date</td>
                            <td style={{ width: "33%" }} className="text-capitalize">{purchaseOrder.quotation_name ?? "-"}</td>
                            <td style={{ width: "34%" }}>{purchaseOrder.quotation_date ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Tag Users</td>
                            <td colSpan={2}>
                                {purchaseOrder && purchaseOrder.usersList && purchaseOrder.usersList.length > 0 ? 
                                    purchaseOrder.usersList.map((u, idx) => <div key={idx}>{u.full_name}</div>) : ""}
                            </td>
                        </tr>
                        {purchaseOrder.po_enable_authorized_signatory && purchaseOrder.po_enable_authorized_signatory == 'Y' && (
                            <tr>
                                <td>Authorized Signatory</td>
                                <td style={{ width: "33%" }} className="text-capitalize" colSpan={2}>
                                    {purchaseOrder.authorized_signatory && purchaseOrder.authorized_signatory.full_name ? 
                                        purchaseOrder.authorized_signatory.full_name : "-"}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>Currency</td>
                            <td colSpan={2}>
                                <b>{purchaseOrder.currency}</b> 
                                {purchaseOrder.currency !== purchaseOrder.base_currency ? 
                                    <span>(1 {purchaseOrder?.currency} : <NumberFormatter number={purchaseOrder?.conversion_rate} precision={2} /> {purchaseOrder?.base_currency})</span> : null}
                            </td>
                        </tr>
                        {purchaseOrder.additional_attributes_data && purchaseOrder.additional_attributes_data.length > 0 && 
                            purchaseOrder.additional_attributes_data.map((attr) => (
                                <tr key={attr.key}>
                                    <td className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                    <td colSpan={2}>{attr.value_display ? attr.value_display : "-"}</td>
                                </tr>
                            ))
                        }
                        <tr>
                            <td>Logistic Details</td>
                            <td colSpan={2}>
                                {purchaseOrder.logistic_edd_data && purchaseOrder.logistic_edd_data.length > 0 && 
                                    purchaseOrder.logistic_edd_data.map((d, k) => (
                                        <div key={k}>
                                            <Link onClick={() => this.logisticDetailModal(d.transaction_id)}>
                                                {d.transaction_id} (EDD : {d.delivery_date ? DateService.dateFormat(d.delivery_date) : 'NA'})
                                            </Link>
                                        </div>
                                    ))
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table className="table table-bordered table-responsive table-fixed bg-white my-3 table-sm" id="poTable">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ "width": '5%' }} className="text-center">
                                <input
                                    type='checkbox'
                                    onChange={this.checkAllCancelItem}
                                    name="chk[]"
                                    disabled={purchaseOrder && purchaseOrder.items && purchaseOrder.items.length > 0 && 
                                        purchaseOrder.items.some((i) => i.pending_qty == 0) ? true : false}
                                    id="all_check_po"
                                />
                            </th>
                            <th style={{ width: "39%" }}>Item Details</th>
                            <th style={{ width: "12%" }}>Requisition</th>
                            <th style={{ width: "12%" }} className="text-end">Quantity</th>
                            <th style={{ width: "8%" }} className="text-end">Unit Rate</th>
                            <th style={{ width: "8%" }} className="text-end">Discount</th>
                            <th style={{ width: "8%" }} className="text-end">Tax</th>
                            <th style={{ width: "8%" }} className="text-end">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchaseOrder && purchaseOrder.items && purchaseOrder.items.length > 0 ? 
                            purchaseOrder.items.map((i, k) => (
                                <tr key={k}>
                                    <td className='text-center'>
                                        {k + 1} <br /> <br />
                                        <input
                                            type='checkbox'
                                            name="foo"
                                            className="po_item_id_checkbox"
                                            value={i.item.id}
                                            data-poItemId={i.po_item_id}
                                            data-pendingQty={i.pending_qty}
                                            disabled={i.pending_qty == 0}
                                        />
                                    </td>
                                    <td>
                                        {i.item ? (
                                            <div className='row'>
                                                <div className='col-sm-10'>
                                                    <ItemViewInList view_hsn={true} item={i.item} remark={i.remark} 
                                                        due_date={i.due_date_display} viewItemModal={() => this.viewItemModalInit(i.item)} />
                                                </div>
                                                <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" 
                                                        className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#" 
                                                        role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu">
                                                        <li>
                                                            <a href="#" className="dropdown-item" onClick={() => this.viewHistoryModalInit(i.item, 'consumption', { indent_transaction_id: i.indent_transaction_id, req_item_id: i.req_item_id })}>
                                                                View History
                                                            </a>
                                                        </li>
                                                        {/* <li>
                                                            <a href="#" className="dropdown-item" onClick={() => this.viewConsumptionModalInit(i.item, k)}>
                                                                Consumption History
                                                            </a>
                                                        </li> */}
                                                        {/* <li>
                                                            <a href="#" className="dropdown-item" onClick={() => this.viewPOHistoryModalInit(i.item, k)}>
                                                                PO History
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" className="dropdown-item" onClick={() => this.viewTransactionLedgerModalInit(i.item, k)}>
                                                                Item Transaction Ledger
                                                            </a>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>
                                        ) : null}
                                    </td>
                                    <td className="text-center">
                                        {i.req_allocation && i.req_allocation.length > 0 ? (
                                            <Ax>
                                                {i.req_allocation.map((r, idx) => (
                                                    <div key={idx} className='my-1 link-primary cursor_pointer' 
                                                        onClick={() => this.reqDetailModalInit(r.requisition_transaction_id)}>
                                                        {r.requisition_transaction_id}: {r.qty}
                                                    </div>
                                                ))}
                                            </Ax>
                                        ) : null}
                                        {(i.additional_qty > 0 ? <div className='my-1'>ADDL.: {i.additional_qty}</div> : null)}
                                    </td>
                                    <td className='text-end'>
                                        {i.qty}
                                        {i.item.measuring_unit && i.item.measuring_unit.name ? 
                                            <span className="text-helping input-group-text text-end pr0">{i.item?.measuring_unit?.name}</span> : null}
                                        <div className='my-1'>Pending : {i.pending_qty}</div>
                                        {i.cancelled_qty && i.cancelled_qty > 0 ? 
                                            <div className='my-1'>Cancelled : {i.cancelled_qty}</div> : null}
                                    </td>
                                    <td className='text-end'>{i.rate_vc}</td>
                                    <td className='text-end'>
                                        {i.discount_rate_vc ? 
                                            <div>{i.discount_type == "Fixed" ? purchaseOrder.currency : null} {i.discount_rate_vc} {i.discount_type == "Percentage" ? "%" : null}</div> : 0}
                                    </td>
                                    <td className='text-end'>
                                        {purchaseOrder && purchaseOrder.vendor_gstin && purchaseOrder.gst_as_applicable && 
                                            purchaseOrder.gst_as_applicable == 'N' && purchaseOrder.gst_not_applicable && 
                                            purchaseOrder.gst_not_applicable == 'N' ? 
                                            <div>{i.gst} %</div> : (purchaseOrder.gst_as_applicable && purchaseOrder.gst_as_applicable == 'Y') ? "-" : "NA"}
                                        {purchaseOrder && purchaseOrder.vendor_gstin && i.item && purchaseOrder.gst_not_applicable == 'N' ? 
                                            <span className="text-helping input-group-text text-end pr0">
                                                {purchaseOrder.vendor_address && purchaseOrder.vendor_address.state_name == purchaseOrder.warehouse_address.state_name ? "GST" : "IGST"}
                                            </span> : null}
                                    </td>
                                    <td className='text-end'>
                                        <CurrencyFormatter currencyCode={purchaseOrder.currency} amount={parseFloat(i.item_with_discount).toFixed(2)} />
                                    </td>
                                </tr>
                            ))
                            : <tr><td className='text-center' colSpan={8}>No Record</td></tr>
                        }
                    </tbody>
                </table>

                <div className="row align-items-center mb-5">
                    <div className="col-6">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <div>{purchaseOrder.notes ?? "-"}</div>
                    </div>
                    <div className="col-6">
                        <table className="table table-borderless">
                            <tbody>
                                <tr className="subtotal_bg_color">
                                    <th>Sub-Total ({purchaseOrder.currency ? purchaseOrder.currency : "INR"})</th>
                                    <td className='float-end'>
                                        {purchaseOrder && purchaseOrder.items && purchaseOrder.items.length > 0 && 
                                            <CurrencyFormatter currencyCode={purchaseOrder.currency} 
                                                amount={purchaseOrder.items.map(s => Number(s.item_with_discount)).reduce((a, b) => a + b, 0).toFixed(2)} />}
                                    </td>
                                </tr>
                                {purchaseOrder && purchaseOrder.tcs_rate_vc && purchaseOrder.tcs_rate_vc > 0 ? (
                                    <tr className="subtotal_bg_color">
                                        <th>TCS ({purchaseOrder.tcs_type == "Fixed" ? purchaseOrder.currency : null} {purchaseOrder.tcs_rate_vc} {purchaseOrder.tcs_type == "Percentage" ? "%" : null})</th>
                                        <td className='float-end'><NumberFormatter number={tcs_amount} precision={2} /></td>
                                    </tr>
                                ) : null}
                                {purchaseOrder.tax_slabs && purchaseOrder.tax_slabs.length > 0 && purchaseOrder.gst_as_applicable && purchaseOrder.gst_as_applicable == 'N' ? 
                                    (purchaseOrder.tax_slabs.map((ps, idx) => (
                                        <tr className="subtotal_bg_color" key={idx}>
                                            <th>{ps.key}</th>
                                            <td className="text-end">{ps.value}</td>
                                        </tr>
                                    ))) : null
                                }
                                {purchaseOrder.gst_as_applicable && purchaseOrder.gst_as_applicable == 'Y' && 
                                    purchase_summary.map((ps, idx) => (
                                        <tr className="subtotal_bg_color" key={idx}>
                                            <th>{ps.key}</th>
                                            <td className="text-end">{ps.value}</td>
                                        </tr>
                                    ))
                                }
                                <tr className="subtotal_bg_color">
                                    <th>Adjustment</th>
                                    <td className='float-end'>{purchaseOrder.adjustment_amount_vc ?? 0}</td>
                                </tr>
                                <tr className="subtotal_bg_color">
                                    <th>Final Total ({purchaseOrder.currency ? purchaseOrder.currency : "INR"})</th>
                                    <td className='float-end'>
                                        {purchaseOrder.total_amount_vc ? 
                                            <CurrencyFormatter currencyCode={purchaseOrder.currency} amount={purchaseOrder.total_amount_vc} /> : 0}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="tab_content_wrapper content_heading">Terms & Condition</div>
                <table className="table table-hover table-bordered bg-white my-3">
                    <thead className='table-secondary'>
                        <tr>
                            <th className='text-center' style={{ width: "10%" }}>S.No</th>
                            <th className='text-start' style={{ width: "25%" }}>Name</th>
                            <th className='text-start' style={{ width: "65%" }}>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchaseOrder.tnc && purchaseOrder.tnc.length > 0 ? 
                            purchaseOrder.tnc.map((tc, k) => (
                                <tr key={k}>
                                    <td className='text-center'>{k + 1}</td>
                                    <td>{tc.name}</td>
                                    <td dangerouslySetInnerHTML={{ __html: tc.text }} />
                                </tr>
                            ))
                            : <tr><td className='text-center' colSpan={3}>No Record</td></tr>
                        }
                    </tbody>
                </table>

                {this.props.renderAs == 'inline' && (
                    <>
                        <PurchaseOrderDocument purchaseDetails={purchaseOrder} getPODetail={(id) => this.getPODetail(id)} />
                        <hr />
                        
                        {purchaseOrder.status == 5 || purchaseOrder.status == 6 ? null : (
                            <div>
                                <div className="tab_content_wrapper" ref={this.myRef}>
                                    <span className="content_heading">Comments & History</span>
                                </div>
                                {this.state.allAllowedStatus && (
                                    <form onSubmit={this.submitUpdateCommentForm}>
                                        <div className="my-3 row">
                                            <label className="col-sm-3 col-form-label">Change status to</label>
                                            <div className="col-sm-5">
                                                <TapSelect
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'addCommentForm', 'status');
                                                    }}
                                                    value={this.state.allAllowedStatus.find(s => s.value == this.state.addCommentForm.status)}
                                                    options={this.state.allAllowedStatus}
                                                    isSearchable={false}
                                                    isDisabled={this.state.poDetail?.change_status == "N" || 
                                                        !this.props.permissions || !this.props.permissions.includes('isc-po-status-change')}
                                                    placeholder="Please Select Status"
                                                />
                                            </div>
                                        </div>
                                        <div className="my-2">
                                            <label className="form-label">Comments</label>
                                            <textarea
                                                name="notes"
                                                value={this.state.addCommentForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'addCommentForm')}
                                                className="form-control"
                                                placeholder="Please Add a comment"
                                                required
                                                style={{ height: "100px" }}
                                            />
                                        </div>
                                        <div className="col-12 text-end">
                                            <button type="submit" disabled={this.state.addCommentFormSubmitting} className="btn btn-primary mx-2">
                                                Update {this.state.addCommentFormSubmitting && 
                                                    (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />)}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        )}
                        <hr />
                        <div className="my-1">
                            {purchaseOrder.comments && purchaseOrder.comments.length > 0 && 
                                purchaseOrder.comments.map((c, k) => (
                                    <Ax key={k}>
                                        <div className="row">
                                            {c.msg ? <div className="col-sm-8" dangerouslySetInnerHTML={{ __html: c.msg }} /> : 
                                                <div className='col-sm-8'>-</div>}
                                            <div className="col-sm-4 text-end">
                                                <tapIcon.imageIcon icon={tapIcon.CalenderIcon} className="img-fluid pr-5 fs12" alt="item-action" />
                                                <span> {c.created_at_display}</span>
                                            </div>
                                            <div className="col-sm-8 my-1">{c.notes}</div>
                                        </div>
                                        <hr />
                                    </Ax>
                                ))
                            }
                        </div>
                    </>
                )}
            </div>
        );
    }

    reqDetailJsx = () => {
        return (
            <div className="modal fade" id={this.PODetailModalID} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">PO Detail : {this.state.poTransactionId ?? "-"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.renderDetailContent()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.renderAs === 'inline') {
            // Render as inline component (for list view)
            return (
                <div className="purchase-order-detail-inline">
                    {this.renderDetailContent()}
                    
                    {/* Child modals */}
                     <ItemTransactionLedger ref={this.transactionLedgerRef} />
                      <ItemDetailsModal ref={this.itemDetailsRef} />
                      <VendorDetailModal ref={this.VendorDetailModalRef} />
                <LogisticViewModal ref={this.LogisticViewModalRef} />
                <HistoryDataModal ref={this.HistoryRef} onLogisticClick={this.logisticDetailModal} />
                      {!this.props?.openedFrom && <RequisitionDetailModal parentProps={this.props} ref={this.ReqDetailModalRef} /> }
                                       <POCancel 
                    ref={this.cancelledItemModalRef} 
                    getPODetail={(id) => this.getPODetail(id)}
                    onCancelComplete={(id) => {
                        if (this.props.onUpdate) {
                            this.refreshPODetail(id)
                            this.props.onUpdate(id);
                        }
                    }}
                />


                </div>
            );
        }
        
        // Render as modal
        return (
            <div>
                {this.reqDetailJsx()}
                  <ItemDetailsModal ref={this.itemDetailsRef} />
                  <VendorDetailModal ref={this.VendorDetailModalRef} />
                <LogisticViewModal ref={this.LogisticViewModalRef} />
                <HistoryDataModal ref={this.HistoryRef} onLogisticClick={this.logisticDetailModal} />
                   {!this.props?.openedFrom && <RequisitionDetailModal parentProps={this.props} ref={this.ReqDetailModalRef} /> }

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions: state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : [],
        settings: state.app.setting,
        orgInfoData: state.app.group_info ? state.app.group_info : null,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(PurchaseOrderDetailModal);